export const NODE_NAME = 'tab_view';
